module.exports = __webpack_public_path__ + "img/banner.547d593f.png";